module.exports = __webpack_public_path__ + "static/media/ShowUpText.da336a3f.png";